import { useCallback } from "react";
import { BooksProduct } from "./BooksProduct";
import { ProductGroup } from "store/apis/products";
import BillingSubscription from "components/billing/BillingSubscription";
import { MailroomProduct } from "./MailroomProduct";
import { SalesTaxProduct } from "./SalesTaxProduct";
import { IntragroupProduct } from "./IntragroupProduct";

export const SearchedSubscriptionsServices = ({
  products,
}: {
  products: Record<string, ProductGroup>;
}) => {
  const order = ["BOOKS", "TAX", "MAILROOM", "RND", "SALES_TAX", "INTRA_GROUP"];
  const handleProduct = useCallback(
    ({ type, categories }: { type: string; categories: ProductGroup }) => {
      switch (type) {
        case "BOOKS":
          return <BooksProduct booksProduct={categories} isSearch />;
        case "TAX":
          return <BillingSubscription taxProduct={categories} isSearch />;
        case "MAILROOM":
          return <MailroomProduct mailroomProduct={categories} isSearch />;
        case "SALES_TAX":
          return <SalesTaxProduct salesTaxProduct={categories} isSearch />;
        default:
          return <IntragroupProduct intragroupProduct={categories} isSearch />;
      }
    },
    []
  );
  return (
    <section>
      {Object.entries(products)
        .sort(([productTypeA], [productTypeB]) => {
          return order.indexOf(productTypeA) - order.indexOf(productTypeB);
        })
        .map(([productType, categories], index) => (
          <div key={index} className="t-flex t-flex-wrap t-py-2">
            {handleProduct({ type: productType, categories })}
          </div>
        ))}
    </section>
  );
};
